<template>
  <transition name="fade">
    <button v-if="isVisible" @click="scrollToTop" class="fab">
      <img
        src="@/assets/icons/icon-arrow-top-white-40x40-min.svg"
        alt="Go to top"
      />
    </button>
  </transition>
</template>

<script>
export default {
  name: 'GoToTopButton',
  data() {
    return {
      isVisible: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isVisible = window.scrollY > 200
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style scoped>
.fab {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: var(--p2);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  transition: opacity 0.3s, transform 0.3s;
}

.fab:hover {
  background-color: var(--color-primary);
  transform: scale(1.1);
}

.fab img {
  width: 24px;
  height: 24px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
